const ValidationErrors = (props) => {
    return (
        <div className='validation-errors'>
            <ul className='validation-error__list visually-hidden' aria-live="polite">
                {props.errors && Object.keys(props.errors).length > 0 && Object.values(props.errors).map((value, index) => {
                    return (
                        <li className='validation-errors__list-item' key={index}>{value}</li>
                    );
                })}
            </ul>
        </div>
    );
}

export default ValidationErrors;